import { render, staticRenderFns } from "./AllWorkFlow.vue?vue&type=template&id=2b84882a&scoped=true&"
import script from "./AllWorkFlow.vue?vue&type=script&lang=js&"
export * from "./AllWorkFlow.vue?vue&type=script&lang=js&"
import style0 from "./AllWorkFlow.vue?vue&type=style&index=0&id=2b84882a&prod&lang=scss&scoped=true&"
import style1 from "./AllWorkFlow.vue?vue&type=style&index=1&id=2b84882a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84882a",
  null
  
)

export default component.exports